import React from 'react'
import { EditOutlined } from '@ant-design/icons'
import { Button } from 'antd'

export default (props) => {
  return (
    <div>
      <Button block type='primary' size='large' htmlType='submit'>
        <EditOutlined />
        <span style={{ fontSize: 14 }}>{props.text}</span>
      </Button>
    </div>
  )
}
